import React from 'react';
import {connect} from 'react-redux';
import {Col, Glyphicon, Button} from 'react-bootstrap'
import classnames from 'classnames';

const Staff = ({staff, open, row, onEditStaffClicked, onResendClicked}) => {

  let status = staff.status;
  if (!status) {
    status = '';
  }
  const isEditable = status !== 'disabled';

  return (
    <Col md={4} sm={6}>
      <div className={classnames('panel', 'relationships-item', {open: open})}>
        <div className="panel-body">
          <div className="relationships-name">{staff.name}</div>
          <div className="role">{staff.user_group.name}</div>
        </div>

        <div className={classnames('text-center panel-footer', status)}>
          <div className={"status"} >{status.toUpperCase()}</div>
          {isEditable &&
            <Button className="white-ghost-btn edit-staff-details-btn"
                                   onClick={() => onEditStaffClicked(staff.links.edit, row, staff.id)}><Glyphicon glyph="pencil"/>EDIT DETAILS</Button>}
           <div className="clearfix"/>
        </div>
      </div>
    </Col>
  );
};

const mapStateToProps = (state) => {
  return {
    staff_member_row: state.staff.staff_member_row,
    staff_member_id: state.staff.staff_member_id
  };
};

export default connect(mapStateToProps)(Staff);


// WEBPACK FOOTER //
// ./src/components/store-details/staff.jsx